module.exports = __webpack_public_path__ + "static/media/manual-synonyms-guide.e844d643.png";